import {localStorageGet, LANG} from "@/localStorage";

export default localStorageGet(LANG) || 'en'
